module.exports = __webpack_public_path__ + "img/6.3db0fd71.jpg";